<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative pr-83">
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Date of Inspection" oneline>{{ Item.created_at ? $options.filters.formatDatebyMoment(Item.created_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Lift Number" oneline>{{ Item.equipment && Item.equipment.tag_name ? Item.equipment.tag_name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="4">
                            <gofix-text-field label="Number Of Infringements" oneline>{{ Item.number_of_infringements }}</gofix-text-field>
                        </b-col>
                        <b-col md="4"></b-col>
                        <b-col md="4">
                            <gofix-text-field classInner="justify-content-end" label="Status" oneline>{{ Item.status }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Submitted Date" oneline>{{ Item.submitted_at ? $options.filters.formatDatebyMoment(Item.submitted_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Submitted By" oneline>{{ Item.submitted_by && Item.submitted_by.name ? Item.submitted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Contractor Company" oneline>{{ Item.supplier }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Completed Date" oneline>{{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Completed By" oneline>{{ Item.completed_by && Item.completed_by.name ? Item.completed_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Project Manager" oneline>{{ Item.project_manager_by && Item.project_manager_by.name ? Item.project_manager_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Acknowledged Date" oneline>{{ Item.acknowledged_at ? $options.filters.formatDatebyMoment(Item.acknowledged_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Acknowledged By" oneline>{{ Item.acknowledged_by && Item.acknowledged_by.name ? Item.acknowledged_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Location" oneline>{{ Item.location }} {{ Item.equipment_type }} {{ Item.equipment_lift_number }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <gofix-text-field classLabel="flex-105" label="Project Name" oneline>{{ Item.project && Item.project.contract_title ? Item.project.contract_title : '' }}</gofix-text-field>
                </b-col>
                <b-col md="6">
                    <gofix-text-field classLabel="flex-105" label="Comment" oneline>{{ Item.comment_so && Item.comment_so.description ? Item.comment_so.description : '' }}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <gofix-text-field label="BU" oneline>{{ Item.description ? Item.description : '' }}</gofix-text-field>
                </b-col>
            </b-row>
            <span v-if="$checkRole(this.$accessModule.safety_inspection_checklist, 'update') && Item && Item.status != 'Completed'" style="top: 0 !important; right: 31px !important;" @click="editBacsicInfo" class="editBox position-absolute cursor-pointer">
                <img src="img/iconPencil.png" alt="edit bacsic info" with="18px" height="18">
            </span>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Basic Info" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <b-row class="mb-10">
                    <b-col md="12">
                         <gofix-text-field class="mb-10" label="Project Name" oneline>{{ Item.project_id }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Contractor Company" oneline>{{ Item.supplier }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Location"  oneline>{{ Item.properties && Item.properties.name ? Item.properties.name : '' }}</gofix-text-field>
                    </b-col>
                </b-row>
                <br />
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :disabled="modals.bacsicInfo.options.status.length == 0"
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                    <dropdown-user-duties 
                        v-if="Item.status == 'New'"
                        label="Submitted By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        :reduce="option => option.user_id"
                        :safetyOnlyFM="true"
                        role-name="Safety Officer"
                        v-model="modals.bacsicInfo.data.submitted_by_id">
                    </dropdown-user-duties>
                    <dropdown-user-duties 
                        v-if="Item.status == 'Submitted'"
                        label="Acknowledged By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        :company-id="Item.supplier && Item.supplier.id ? Item.supplier.id : null"
                        :reduce="option => option.user_id"
                        role-name="Contractor Supervisor"
                        v-model="modals.bacsicInfo.data.acknowledged_by_id">
                    </dropdown-user-duties>
                    <dropdown-user-duties 
                        v-if="Item.status == 'Contractor Acknowledged'"
                        label="Acknowledged By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        :company-id="Item.supplier && Item.supplier.id ? Item.supplier.id : null"
                        :reduce="option => option.user_id"
                        role-name="Contractor Supervisor"
                        v-model="modals.bacsicInfo.data.completed_by_id">
                    </dropdown-user-duties>
                    <b-row v-if="Item.status == 'New'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.submitted_at" label="Submitted Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Submitted Time" v-model="modals.bacsicInfo.data.submitted_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="Item.status == 'Submitted'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.acknowledged_at" label="Acknowledged Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Acknowledged Time" v-model="modals.bacsicInfo.data.acknowledged_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="Item.status == 'Contractor Acknowledged'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.completed_at" label="Completed Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Completed Time" v-model="modals.bacsicInfo.data.completed_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="checkShowPopUpSignature" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    export default {
        name: 'safety-inspection-checklist-detail-info',
        components: {
            DropdownUserDuties
        },
        props: {
            checklistEntries: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            completed_by_id: null,
                            acknowledged_by_id: null,
                            submitted_by_id: null,
                            submitted_at: null,
                            submitted_at_hour: null,
                            acknowledged_at: null,
                            acknowledged_at_hour: null,
                            completed_at: null,
                            completed_at_hour: null,
                        },
                        options: {
                            status: ['Submitted', 'Contractor Acknowledged', 'Completed'],
                            fm_users: [],
                            supllier_users: [],
                        }
                    }
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Contractor Acknowledged'],
                    'Contractor Acknowledged': ['Completed'],                    
                }
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            jobOptionStatus() {
                return this.option_status[this.Item.status];
            },
        },
        created() {
            
        },
        methods: {
            /*-- Get Data --------*/
            editBacsicInfo() {
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    completed_by_id: this.Item.completed_by_id,
                    acknowledged_by_id: this.Item.acknowledged_by_id,
                    submitted_by_id: this.Item.submitted_by_id,
                    submitted_at: this.Item.submitted_at ? new Date(this.Item.submitted_at) : null,
                    submitted_at_hour: this.Item.submitted_at ? moment(new Date(this.Item.submitted_at)).format("HH:mm") : null,
                    acknowledged_at: this.Item.acknowledged_at ? new Date(this.Item.acknowledged_at) : null,
                    acknowledged_at_hour: this.Item.acknowledged_at ? moment(new Date(this.Item.acknowledged_at)).format("HH:mm") : null,
                    completed_at: this.Item.completed_at ? new Date(this.Item.completed_at) : null,
                    completed_at_hour: this.Item.completed_at ? moment(new Date(this.Item.completed_at)).format("HH:mm") : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            checkShowPopUpSignature() {
                // if(this.bacsicInfo.job_status == 'Completed'
                //     && this.Item.maintenance.number_of_required_signature > 0
                //     && this.Item.signatures.length < this.Item.maintenance.number_of_required_signature
                // ) {
                //     this.is_open_signature = true;
                // } else {
                //     this.updateBasicInfo();
                // }

                this.updateBasicInfo();
            },
            updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                /* All checklists need to be ticked */
                let flagChecklist = false;
                if(this.Item.status == 'New') {
                    for(let i = 0; i < this.checklistEntries.length; i++) {
                        const item = this.checklistEntries[i];
                        if(item.children && item.children.length > 0) {
                            for(let j = 0; j < item.children.length; j++) {
                                const child = item.children[j];
                                if(child.safety_checklist_entries && child.safety_checklist_entries.length) {
                                    for(let k = 0; k < child.safety_checklist_entries.length; k++) {
                                        const entry = child.safety_checklist_entries[k];
                                        if(entry.input.value === false && entry.status == 'Unfilled') {
                                            flagChecklist = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        if(item.safety_checklist_entries && item.safety_checklist_entries.length) {
                            for(let k = 0; k < item.safety_checklist_entries.length; k++) {
                                const entry = item.safety_checklist_entries[k];
                                if(entry.input.value === false && entry.status == 'Unfilled') {
                                    flagChecklist = true;
                                    break;
                                }
                            }
                        }

                        if(flagChecklist) break;
                    }
                }

                if(flagChecklist) {
                    this.modals.bacsicInfo.loading = false;
                    return this.$alertNotification("Please fill all checklist items before submit", "danger");
                }

                let params = this.processJob(this.modals.bacsicInfo.data);
                if(params === false) return

                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: this.Item.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "safe_inspection_checklist"));
                        // this.is_open_signature = false;
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'contractor acknowledged') status = 'acknowledged';
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'acknowledged': {
                        status: 'Contractor Acknowledged',
                        acknowledged_by_id: data.acknowledged_by_id || null,
                        acknowledged_at: null,
                    },
                    'completed': {
                        status: 'Completed',
                        completed_by_id: data.completed_by_id || null,
                        completed_at: null,
                    },
                };
                

                const obj = defaultStatus[status];

                if(!obj[`${status}_by_id`]) {
                    this.$alertNotification(`Please select ${obj.status} By`, "danger");
                    return false
                }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            }
        }
    }
</script>
<style lang="scss">
    .flex-105 {
        flex: 0 0 105px;
    }
</style>